/*
 * @Author: ruiwang
 * @Date: 2024-02-24 15:50:47
 * @Last Modified by: ruiwang
 * @Last Modified time: 2024-02-29 17:57:49
 */
export const fieldsMap = {
    name: '氏名（姓名）',
    nameKana: 'フリガナ',
    sex: '性別',
    birthday: '生年月日',
    postalCode: '郵便番号（ハイフン除く７桁の半角数字）',
    address: '住所（都道府県）',
    addressDetail: '住所（市区町村・丁目・番地号）',
    addressBuilding: '住所（建物名・部屋番号）',
    telephone: '電話番号',
    bankName: '銀行名',
    branchName: '支店名',
    accountType: '口座種類',
    accountNumber: '口座番号',
    accountHolder: '口座名義人',
    investmentExperience: '投資経験(複数可)',
    investmentExperienceYears: '投資経験（年数）',
    financialAssets: '金融資産（万円）',
    occupation: '職業等',
    income: '年収（万円）',
    investmentPolicy: '投資方針※（複数可）',
    securitiesAccount: '証券口座',
    lossOfPrincipal: '元本毀損で生活に支障'
};
const sexOptions = [
    {
        label: '男性',
        value: 'Male',
    },
    {
        label: '女性',
        value: 'Female',
    }
];
const accountTypeOptions = [
    {
        label: '普通',
        value: 'Normal',
    },
    {
        label: '当座',
        value: 'Current',
    }
];
const investmentExperienceOptions = [
    {
        label: '国内株式',
        value: 1,
    },
    {
        label: '国内債券',
        value: 2,
    },
    {
        label: '外国株式',
        value: 3,
    },
    {
        label: '外国債券',
        value: 4,
    },
    {
        label: '投資信託・ETF',
        value: 5,
    },
    {
        label: '金融先物・オプション',
        value: 6,
    },
    {
        label: 'ファンド',
        value: 7,
    },
    {
        label: '外国為替証拠金取引',
        value: 8,
    },
    {
        label: '仮想通貨',
        value: 9,
    }
];
const investmentExperienceYearsOptions = [
    {
        label: '１～３',
        value: 1,
    },
    {
        label: '３～５',
        value: 2,
    },
    {
        label: '５以上',
        value: 3,
    }
];
const occupationOptions = [
    {
        label: '会社員',
        value: 1,
    },
    {
        label: '公務員',
        value: 2,
    },
    {
        label: '自営業者',
        value: 3,
    },
    {
        label: '年金生活者',
        value: 4,
    },
    {
        label: 'パート・アルバイト',
        value: 5,
    }
];
const investmentPolicyOptions = [
    {
        label: '短期売買',
        value: 1,
    },
    {
        label: '短中期投資',
        value: 2,
    },
    {
        label: '長期投資',
        value: 3,
    },
    {
        label: '資産分散投資',
        value: 4,
    },
    {
        label: '預貯金以上の利回り志向',
        value: 5,
    },
    {
        label: '外国為替差益',
        value: 6,
    }
];
const securitiesAccountOptions = [
    {
        label: '有',
        value: 1,
    },
    {
        label: '無',
        value: 2,
    }
];
const lossOfPrincipalOptions = [
    {
        label: 'はい',
        value: 1,
    },
    {
        label: 'いいえ',
        value: 2,
    }
];
export const options1 = [
    ['name', { placeholder: '東京　太郎' }],
    ['nameKana', { placeholder: 'トウキョウ　タロウ' }],
    ['sex', {
            type: 'radio', options: sexOptions
        }],
    ['birthday', {
            type: 'date', placeholder: '29362'
        }],
    'postalCode',
    ['address', { placeholder: '東京都' }],
    ['addressDetail', { placeholder: '荒川区荒川５丁目　１０－２０' }],
    ['addressBuilding', { required: false }],
    ['telephone', { placeholder: '123456789' }]
];
export const options2 = [
    ['bankName', { placeholder: '三菱UFJ銀行' }],
    ['branchName', { placeholder: '青山支店' }],
    ['accountType', {
            type: 'radio', options: accountTypeOptions,
            placeholder: '普通口座'
        }],
    ['accountNumber', { placeholder: '1234567' }],
    ['accountHolder', { placeholder: 'インスタキャッシュ(力' }]
];
export const options3 = [
    ['investmentExperience', { type: 'checkbox', options: investmentExperienceOptions }],
    ['investmentExperienceYears', { type: 'radio', options: investmentExperienceYearsOptions }],
    ['financialAssets', { suffix: '万円' }],
    ['occupation', { type: 'radio', options: occupationOptions }],
    ['income', { suffix: '万円' }],
    ['investmentPolicy', { type: 'checkbox', options: investmentPolicyOptions }],
    ['securitiesAccount', { type: 'radio', options: securitiesAccountOptions }],
    ['lossOfPrincipal', {
            type: 'radio', options: lossOfPrincipalOptions,
            rules: [{
                    validator: (rule, value, callback) => {
                        let msg = '';
                        if (value === 1) {
                            msg = '「はい」を選択したお客様にはご登録できません。';
                        }
                        callback(msg);
                    }
                }]
        }]
];
export const genOptions = (opts, map) => {
    return opts.map((tar) => {
        const required = true;
        if (!Array.isArray(tar)) {
            const field = tar;
            const label = (map === null || map === void 0 ? void 0 : map[field]) || field;
            return {
                required,
                label,
                field,
            };
        }
        const [field, def] = tar;
        const label = (map === null || map === void 0 ? void 0 : map[field]) || field;
        return Object.assign({ required,
            label,
            field }, def);
    });
};
